import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DPNUser } from '@shared/models';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Observable, Observer, of } from 'rxjs';
import { switchMap, tap, map } from 'rxjs/operators';
import { AdminUsersApiService } from '../users.service';
import { ComponentContext } from '../../../modules/modal/modal.model';

@Component({
  selector: 'gcc-add-user-modal',
  templateUrl: './add-user-modal.component.html',
  styleUrls: ['./add-user-modal.component.scss'],
  standalone: false
})
export class AddUserModalComponent implements OnInit, ComponentContext<{}, DPNUser> {
  @Input() public onAction: (value: DPNUser) => void;
  @Input() public onClose: () => void;

  public searchControl: FormControl;
  public users$: Observable<DPNUser[]>;
  public selectedUser: DPNUser;
  public noResult = false;
  public isLoading = false;
  public userAlreadyExists = false;

  constructor(public usersApi: AdminUsersApiService) {}

  public ngOnInit(): void {
    this.searchControl = new FormControl('');

    this.users$ = new Observable((observer: Observer<string>) => {
      observer.next(this.searchControl.value);
    }).pipe(
      switchMap(value => {
        return value && value.length >= 2 ? this.usersApi.search(value) : of([]);
      }),
      tap(users => (this.userAlreadyExists = users.length && !users.filter(user => !user.disabled).length)),
      map(users => users.filter(user => !user.disabled))
    );
  }

  public onSelect(event: TypeaheadMatch): void {
    this.selectedUser = event.item;
    this.searchControl.patchValue('');
  }

  public onRemove(): void {
    this.selectedUser = null;
    this.searchControl.patchValue('');
  }

  public onAdd() {
    this.onAction(this.selectedUser);
  }

  public typeaheadNoResults(event: boolean): void {
    this.noResult = this.searchControl.value === '' || this.selectedUser ? false : event;
  }

  public typeaheadLoading(event: boolean): void {
    this.isLoading = event;
  }
}
